/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_GenerateInputs */

const en_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

const de_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren`)
};

const fr_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer`)
};

const es_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar`)
};

const it_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera`)
};

const nl_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereren`)
};

const pl_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj`)
};

const fi_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo`)
};

const da_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer`)
};

const sv_cover_letters_generate = /** @type {(inputs: Cover_Letters_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Cover_Letters_GenerateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_generate = /** @type {((inputs?: Cover_Letters_GenerateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_GenerateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_generate(inputs)
	if (locale === "fr") return fr_cover_letters_generate(inputs)
	if (locale === "es") return es_cover_letters_generate(inputs)
	if (locale === "it") return it_cover_letters_generate(inputs)
	if (locale === "nl") return nl_cover_letters_generate(inputs)
	if (locale === "pl") return pl_cover_letters_generate(inputs)
	if (locale === "fi") return fi_cover_letters_generate(inputs)
	if (locale === "da") return da_cover_letters_generate(inputs)
	if (locale === "sv") return sv_cover_letters_generate(inputs)
	return en_cover_letters_generate(inputs)
});